import { validator } from "LIB/validate-this";
import * as rules from "LIB/validation/rules";
import {
  CONSIGNMENT_BUYER_ID,
  CONSIGNMENT_REFERENCE,
  CONSIGNMENT_REFERENCE_COMPANY_ID,
  CONSIGNOR_PERCENTAGE
} from "MODULES/Receiving/constants";
import {
  STORE_LOCATION_ID,
  STORE_OWNER_ID
} from "MODULES/inventories/constants";

export default function validate(values) {
  return validator(values, form => {
    form
      .validate(
        CONSIGNMENT_REFERENCE_COMPANY_ID,
        CONSIGNMENT_REFERENCE,
        CONSIGNOR_PERCENTAGE,
        CONSIGNMENT_BUYER_ID,
        STORE_LOCATION_ID,
        STORE_OWNER_ID
      )
      .satisfies(rules.required);
  });
}



// WEBPACK FOOTER //
// ./app/modules/Consignments/Search/Create/validate.js